<script setup lang="ts">
import { Search } from 'lucide-vue-next'
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from '@/components/ui/input-group'

const props = withDefaults(defineProps<{
  modelValue: string
  placeholder?: string
}>(), { placeholder: 'Hľadať...' })

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()
</script>

<template>
  <InputGroup class="h-10 rounded-[10px] border-gray-300 dark:border-gray-700">
    <InputGroupAddon class="ps-3.5 pe-0">
      <Search class="size-5 text-gray-700 dark:text-gray-300" />
    </InputGroupAddon>
    <InputGroupInput
      type="text"
      :placeholder="placeholder"
      :value="props.modelValue"
      class="text-sm placeholder:text-gray-400 dark:placeholder:text-gray-500"
      @update:model-value="emit('update:modelValue', String($event ?? ''))"
    />
  </InputGroup>
</template>
